import Utils from '@/scripts/Utils';

const createLabels = (startDate, endDate, mode) => {
  let labels = []
  let dates = []
  switch (mode) {
    case 'day':
    case 'estimed':
    case '7days':
    case 'interval':
      dates = Utils.generateDaysByInterval(startDate, endDate)
      labels = dates.map((date) => ({ date, liters: 0, label: Utils.formatDate(date, '<dd>/<MM>') }))
      break;
    case 'month':
      dates = Utils.generateMonthsByInterval(startDate, endDate)
      labels = dates.map((date) => ({ date, liters: 0, label: Utils.formatMonthDate(date, '<MM>/<YY>') }))
      break;
    case 'hour':
      dates = Utils.generateHoursByInterval(startDate, endDate)
      labels = dates.map((date) => ({ date, liters: 0, label: Utils.formatDate(date, '<hh>:<mm>') }))
      break;
  }
  return labels;
}

const checkPeriod = (labels, mode) => {

  let permittedStartDate = null;
  let permittedEndDate = null;
  switch (mode) {
    case 'day':
    case 'estimed':
    case '7days':
    case 'interval':
      if (labels.length > 90) {
        permittedStartDate = labels[0].label
        permittedEndDate = labels[89].label
      }
      break;
    case 'hour':
      if (labels.length > 24) {
        permittedStartDate = labels[0].label
        permittedEndDate = labels[23].label
      }
      break;
    case 'month':
      if (labels.length > 12) {
        permittedStartDate = labels[0].label
        permittedEndDate = labels[11].label
      }
      break;
  }
  return {
    permittedStartDate,
    permittedEndDate
  }
}

const getSeriesFromReservoirs = async (reservoirs = []) => {
  return reservoirs.map((reservoir) => Array.isArray(reservoir?.series) ? reservoir.series : [])
}

const getSectorPort = (sector) => {
  const port = Number(sector?.port)
  return Number.isFinite(port) && port > 0 ? port : 1
}

const getDeviceCommunicationType = (sector) => {
  const type = String(sector?.deviceCommunicationType ?? "").trim().toUpperCase()
  return type || "LORAWAN"
}

const getReadingValue = (reading, sector) => {
  if (!reading) return null

  if (getDeviceCommunicationType(sector) === "LTE") {
    const ltePort = getSectorPort(sector) === 1 ? "AN1" : "AN2"
    if (!reading.lte) return null
    const payloadKey = Object.keys(reading.lte).find((key) => key.toUpperCase() === ltePort)
    return payloadKey ? Number(reading.lte[payloadKey]) : null
  }

  const lorawanPort = getSectorPort(sector) === 1 ? 6 : 7
  return Array.isArray(reading.decoded) ? reading.decoded[lorawanPort] / 10 : null
}


const createResumeConsumption = (rawReadings, modems, labels, unitMeasurement, isToPredict = true) => {
  let resume = {}
  // Cálcular a estimativa caso exista data futura
  let nowHourOclock = Utils.getHourOclock('now')
  let nextHourOclock = Utils.add_hour(nowHourOclock)
  let isCubicMetersSelected = unitMeasurement == 'cubic_meters' ? true : false;
  for (let modemId in rawReadings) {
    resume[modemId] = {
      modemId,
      total_liters: 0,
      total_cubic_meters: 0,
      average_liters: 0,
      average_cubic_meters: 0,
      estimative_total_liters: 0,
      estimative_total_cubic_meters: 0,
      measured_total: 0,
      estimated_total: 0,
      average: 0,
      readings: labels.map((item) => ({ ...item, isEstimative: false })),
      labels: labels.map((item) => item.label),
      nowHourOclock,
      nextHourOclock,
      modem: null,
      modemName: modems.find((modem) => modem.id_modem === modemId).name,
      unitMeasurement,
    }
  }
  for (let modemId in resume) {
    let existingLitersTotal = 0
    let modem = modems.find((m) => m.id == modemId)
    if (modem) {
      resume[modemId].modem = modem
      resume[modemId].modemName = modem.name
    }
    resume[modemId].readings = resume[modemId].readings.map(
      (reading) => {
        let label = reading.label
        let liters = reading.liters
        let date = reading.date
        let rawReading = rawReadings.hasOwnProperty(modemId) ? rawReadings[modemId].find((raw) => raw.datetime.getTime() === date.getTime()) : undefined
        let isEstimative = reading.date.getTime() >= nextHourOclock.getTime()
        if (isEstimative && !isToPredict) return null;
        if (rawReading) {
          liters = rawReading.liters
        } else if (isEstimative) {
          liters = resume[modemId].average_liters
        }
        if (!isEstimative) {
          existingLitersTotal++
          resume[modemId].total_liters += liters
          resume[modemId].total_cubic_meters += liters / 1000
          resume[modemId].average_liters = resume[modemId].total_liters / (existingLitersTotal > 0 ? existingLitersTotal : 1)
          resume[modemId].average_cubic_meters = resume[modemId].total_cubic_meters / (existingLitersTotal > 0 ? existingLitersTotal : 1)
          resume[modemId].average = !isCubicMetersSelected ? resume[modemId].average_liters : resume[modemId].average_cubic_meters
          resume[modemId].measured_total += !isCubicMetersSelected ? liters : liters / 1000
        }
        resume[modemId].estimative_total_liters += liters
        resume[modemId].estimative_total_cubic_meters += liters / 1000
        resume[modemId].estimated_total += !isCubicMetersSelected ? liters : liters / 1000
        return {
          label,
          water: isCubicMetersSelected ? liters / 1000 : liters,
          water_liters: liters,
          water_cubic_meters: liters / 1000,
          date,
          isEstimative
        }
      }
    ).filter(
      (reading) => {
        return reading !== null;
      }
    )
  }
  return resume;
}
/**
 * 
 * @param {Date} startDate = indica a data inicial (inclusivo)
 * @param {Date} endDate indica a data final (exclusivo)
 * @param {String} mode indica o modo de leitura se é hour = por hora, day = por dia ou month = por mês
 * @param {Array} modems Lista dos modens ao qual será gerado o consumo
 * @param {String} unitMeasurement indica qual unidade de medição do consumo que é liters = litros ou cubic_meters = metros cúbicos
 * @param {Boolean} isToPredict indica se é preciso fazer a predição de resultado para datas futuras escolhido no intervalo
 * @returns objeto com todos os dados da data inicial permitida, a data final permitida, o resumo do consumo por modem e as labels que serão usados para gerar os gráficos
 */
const generateConsumption = async (startDate, endDate, mode, modems, unitMeasurement, isToPredict = true, selectedSector) => {
  let labels = await createLabels(startDate, endDate, mode)
  const { permittedStartDate, permittedEndDate } = checkPeriod(labels, mode)
  const formatedReadings = await getSeriesFromReservoirs(modems)

  // let resume = createResumeConsumption(rawReadings, modems, labels, unitMeasurement, isToPredict)
  return {
    permittedStartDate,
    permittedEndDate,
    formatedReadings,
    labels,
  }
}


const calculateReservoirLevel = (sensorCurrent, reservoirHeight, reservoirVolume, sensorMaxHeight) => {
  const maxCurrent = 20; // mA
  const minCurrent = 4;
  // Normaliza a corrente com base no range do sensor
  const normalizedLevel = (sensorCurrent - minCurrent) / (maxCurrent - minCurrent);
  // Converte para a altura correspondente medida pelo sensor
  const measuredHeight = normalizedLevel * sensorMaxHeight;

  // Ajusta a altura para o reservatório real
  const waterHeight = Math.min(measuredHeight, reservoirHeight);

  // Calcula o volume proporcional
  const waterVolume = (waterHeight / reservoirHeight) * reservoirVolume;

  return {
    waterHeight: waterHeight > 0 ? waterHeight.toFixed(2) : "0",
    waterVolume: waterVolume > 0 ? waterVolume.toFixed(2) : "0"
  };
};

const parseSeriesDate = (date) => {
  if (!date) return null
  if (date instanceof Date) return date
  if (date.seconds != null) return new Date(date.seconds * 1000)
  if (date._seconds != null) return new Date(date._seconds * 1000)
  const parsedDate = new Date(date)
  return Number.isNaN(parsedDate.getTime()) ? null : parsedDate
}

const fillGapsWithInterpolation = (values, labelDates = null) => {
  const now = new Date();
  const realValues = values.filter(val => val !== null);
  const overallAverage = realValues.length > 0
    ? Number((realValues.reduce((sum, val) => sum + val, 0) / realValues.length).toFixed(2))
    : 0;

  const isFutureDate = (index) => {
    if (!labelDates || !labelDates[index]) return false;
    const labelDate = labelDates[index];
    return labelDate instanceof Date ? new Date(labelDate) > now : false;
  };

  const findPreviousValue = (index) => {
    for (let i = index - 1; i >= 0; i--) {
      if (values[i] !== null) return values[i];
    }
    return null;
  };

  const findNextValue = (index) => {
    for (let i = index + 1; i < values.length; i++) {
      if (values[i] !== null) return values[i];
    }
    return null;
  };

  return values.map((val, index) => {
    if (val !== null) return val;
    if (isFutureDate(index)) return null;

    const prevValue = findPreviousValue(index);
    const nextValue = findNextValue(index);

    if (prevValue !== null && nextValue !== null) return Number(((prevValue + nextValue) / 2).toFixed(2));
    if (prevValue !== null) return prevValue;
    if (nextValue !== null) return nextValue;
    return overallAverage;
  });
}

const createPointColors = (estimatedFlags, estimatedColor) => {
  const pointBackgroundColors = estimatedFlags.map((flag) => flag === null ? estimatedColor : undefined);
  const pointBorderColors = estimatedFlags.map((flag) => flag === null ? estimatedColor : undefined);
  return { pointBackgroundColors, pointBorderColors };
}

const createDatasetFromSeries = (series, selectedSector) => {
  const reservoirId = selectedSector.id_doc || selectedSector.id || selectedSector.id_modem
  // Valores e flag estimated vêm prontos do backend (POST /reservoirs/levelPayload)
  const values = (series || []).map((item) => (
    item.value === null || item.value === undefined ? null : Number(item.value)
  ))
  const estimatedFlags = (series || []).map((item) => (
    item.estimated === true ? null : 'real'
  ))
  const estimatedColor = "#FF9800"
  const { pointBackgroundColors, pointBorderColors } = createPointColors(estimatedFlags, estimatedColor)

  return [{
    labels: (series || []).map(({ label }) => label),
    datasets: [{
      label: selectedSector.name,
      data: values,
      type: "line",
      fill: true,
      backgroundColor: "rgba(25, 118, 210, 0.3)",
      borderColor: "#ff0101",
      borderWidth: 2,
      order: 1,
      pointBackgroundColor: pointBackgroundColors,
      pointBorderColor: pointBorderColors,
      pointRadius: estimatedFlags.map((flag) => flag === null ? 6 : 4),
      pointHoverRadius: estimatedFlags.map((flag) => flag === null ? 8 : 6),
      pointBorderWidth: estimatedFlags.map((flag) => flag === null ? 3 : 2),
    }],
    modemId: reservoirId,
  }]
}


const createDataset = (resume, selectedSector, labels) => {
  const reservoirId = selectedSector.id_doc || selectedSector.id || selectedSector.id_modem

  if (Array.isArray(resume?.[0]) && resume[0].some((item) => Object.prototype.hasOwnProperty.call(item, 'value'))) {
    return createDatasetFromSeries(resume[0], selectedSector)
  }

  const consumptionDatasetBarConfig = {
    label: selectedSector.name,
    data: [],
    type: "line",
    fill: true,
    backgroundColor: "rgba(25, 118, 210, 0.3)",
    borderColor: "#ff0101",
    borderWidth: 2,
    order: 1,
  };

  function averageCalc(array) {
    if (array.length === 0) return null; // Retorna null quando não há dados (gap)
    const sum = array.reduce((acumulador, item) => acumulador + item.liters, 0);
    return Number((sum / array.length).toFixed(2));
  }

  function isOnlyTime(label) {
    const timeOnlyRegex = /^\d{2}:\d{2}$/;
    return timeOnlyRegex.test(label);
  }
  
  function campareDate(datetime, label) {
    const timestampMs = datetime.seconds * 1000 + Math.floor(datetime.nanoseconds / 1000000);
    const dateFromTimestamp = new Date(timestampMs);

    const day = ("0" + dateFromTimestamp.getDate()).slice(-2);
    const month = ("0" + (dateFromTimestamp.getMonth() + 1)).slice(-2);
    const formattedDate = `${day}/${month}`;
    return formattedDate === label;
  }

  // Função para gerar labels fixos de hora em hora (00:00 a 23:00)
  function generateFixedHourLabels() {
    const fixedLabels = [];
    for (let hour = 0; hour < 24; hour++) {
      const hourStr = hour.toString().padStart(2, '0');
      fixedLabels.push(`${hourStr}:00`);
    }
    return fixedLabels;
  }

  // Função para obter a hora de um timestamp
  function getHourFromTimestamp(datetime) {
    const timestampMs = datetime.seconds * 1000 + Math.floor(datetime.nanoseconds / 1000000);
    const dateFromTimestamp = new Date(timestampMs);
    return dateFromTimestamp.getHours();
  }

  // Função genérica para preencher gaps com média entre ponto anterior e próximo
  // Apenas preenche gaps no passado/presente, não no futuro
  function fillGapsWithInterpolation(values, labelDates = null) {
    const now = new Date();
    
    // Calcular média geral dos valores reais (fallback quando não há pontos adjacentes)
    const realValues = values.filter(val => val !== null);
    const overallAverage = realValues.length > 0 
      ? Number((realValues.reduce((sum, val) => sum + val, 0) / realValues.length).toFixed(2))
      : 0;
    
    // Função para verificar se uma data está no futuro
    const isFutureDate = (index) => {
      if (!labelDates || !labelDates[index]) return false;
      const labelDate = labelDates[index];
      if (labelDate instanceof Date) {
        const dateToCompare = new Date(labelDate);
        // Comparar com data/hora atual (não resetar horas para modo horário)
        return dateToCompare > now;
      }
      return false;
    };
    
    // Função para encontrar o valor real anterior
    const findPreviousValue = (index) => {
      for (let i = index - 1; i >= 0; i--) {
        if (values[i] !== null) {
          return values[i];
        }
      }
      return null;
    };
    
    // Função para encontrar o valor real próximo
    const findNextValue = (index) => {
      for (let i = index + 1; i < values.length; i++) {
        if (values[i] !== null) {
          return values[i];
        }
      }
      return null;
    };
    
    // Preencher gaps com média entre ponto anterior e próximo (apenas se não for futuro)
    const filledValues = values.map((val, index) => {
      if (val === null) {
        // Verificar se é um gap no futuro - não preencher
        if (isFutureDate(index)) {
          return null; // Manter null para gaps futuros
        }
        
        // É um gap no passado/presente - calcular média entre anterior e próximo
        const prevValue = findPreviousValue(index);
        const nextValue = findNextValue(index);
        
        if (prevValue !== null && nextValue !== null) {
          // Média entre anterior e próximo
          return Number(((prevValue + nextValue) / 2).toFixed(2));
        } else if (prevValue !== null) {
          // Apenas anterior disponível - usar o valor anterior
          return prevValue;
        } else if (nextValue !== null) {
          // Apenas próximo disponível - usar o valor próximo
          return nextValue;
        } else {
          // Nenhum ponto adjacente - usar média geral
          return overallAverage;
        }
      }
      return val;
    });
    
    return filledValues;
  }

  // Função para criar arrays de cores para pontos estimados
  function createPointColors(originalValues, estimatedColor) {
    const pointBackgroundColors = originalValues.map((val) => {
      return val === null ? estimatedColor : undefined; // undefined = usa cor padrão do dataset
    });
    
    const pointBorderColors = originalValues.map((val) => {
      return val === null ? estimatedColor : undefined; // undefined = usa cor padrão do dataset
    });
    
    return { pointBackgroundColors, pointBorderColors };
  }

  let readings = [];
  const isHourlyMode = isOnlyTime(labels[0]?.label);
  
  if (isHourlyMode) {
    // Modo horário: usar labels fixos de 00:00 a 23:00
    const fixedHourLabels = generateFixedHourLabels();
    const hourlyData = new Array(24).fill(null).map(() => []);

    // Agrupar dados por hora
    resume[0].forEach((rawReading) => {
      const hour = getHourFromTimestamp(rawReading.datetime);
      const { waterHeight, waterVolume } = calculateReservoirLevel(
        getReadingValue(rawReading, selectedSector),
        selectedSector.reservoirHeight,
        selectedSector.reservoirVolume,
        selectedSector.sensorMaxHeight,
      );
      hourlyData[hour].push({ ...rawReading, liters: Number(waterVolume) });
    });

    // Calcular média para cada hora
    const hourlyAverages = hourlyData.map((data) => averageCalc(data));
    
    // Criar array de datas para cada hora (usando a data do primeiro label como base)
    const now = new Date();
    const labelDate = labels[0]?.date || now;
    const baseDate = new Date(labelDate);
    baseDate.setHours(0, 0, 0, 0);
    
    const hourlyDates = Array.from({ length: 24 }, (_, hour) => {
      const date = new Date(baseDate);
      date.setHours(hour, 0, 0, 0);
      return date;
    });
    
    // Preencher gaps com interpolação (apenas gaps no passado/presente)
    const dataWithEstimates = fillGapsWithInterpolation(hourlyAverages, hourlyDates);
    
    // Criar arrays de cores para os pontos: laranja para estimados (apenas gaps preenchidos, não futuros)
    const estimatedColor = "#FF9800"; // Laranja para destacar estimativas
    // Marcar como estimado apenas gaps que foram preenchidos (eram null originalmente e foram preenchidos)
    const estimatedFlags = hourlyAverages.map((val, index) => 
      val === null && dataWithEstimates[index] !== null ? null : 'real'
    );
    const { pointBackgroundColors, pointBorderColors } = createPointColors(estimatedFlags, estimatedColor);

    const datasets = [
      {
        // Dataset principal: dados reais + estimados (linha contínua)
        ...consumptionDatasetBarConfig,
        label: selectedSector.name,
        data: dataWithEstimates,
        // Cores diferentes para pontos estimados vs reais
        pointBackgroundColor: pointBackgroundColors,
        pointBorderColor: pointBorderColors,
        pointRadius: estimatedFlags.map((flag) => flag === null ? 6 : 4), // Pontos estimados maiores
        pointHoverRadius: estimatedFlags.map((flag) => flag === null ? 8 : 6), // Hover maior para estimados
        pointBorderWidth: estimatedFlags.map((flag) => flag === null ? 3 : 2), // Borda mais grossa para estimados
      }
    ];

    readings.push({
      labels: fixedHourLabels,
      datasets: datasets,
      modemId: reservoirId,
    });
  } else {
    // Modo não-horário: aplicar mesma lógica de estimativa para gaps
    const labelValues = [];
    const originalValues = [];
    
    labels.map((label) => {
      let data = [];
      resume[0].forEach((rawReading) => {
        if (campareDate(rawReading.datetime, label.label)) {
          const { waterHeight, waterVolume } = calculateReservoirLevel(
            getReadingValue(rawReading, selectedSector),
            selectedSector.reservoirHeight,
            selectedSector.reservoirVolume,
            selectedSector.sensorMaxHeight,
          );

          // Alterado para usar o VOLUME
          data.push({ ...rawReading, liters: Number(waterVolume) });
        }
      });
      const avgValue = averageCalc(data);
      label.liters = avgValue;
      label.raw = data;
      
      // Armazenar valores (null se não há dados)
      originalValues.push(avgValue);
    });

    // Extrair datas dos labels para verificar se são futuras
    const labelDates = labels.map(label => label.date);
    
    // Preencher gaps com interpolação (apenas gaps no passado/presente)
    const dataWithEstimates = fillGapsWithInterpolation(originalValues, labelDates);
    
    // Criar arrays de cores para os pontos: laranja para estimados (apenas gaps preenchidos, não futuros)
    const estimatedColor = "#FF9800"; // Laranja para destacar estimativas
    // Marcar como estimado apenas gaps que foram preenchidos (eram null originalmente e foram preenchidos)
    const estimatedFlags = originalValues.map((val, index) => 
      val === null && dataWithEstimates[index] !== null ? null : 'real'
    );
    const { pointBackgroundColors, pointBorderColors } = createPointColors(estimatedFlags, estimatedColor);

    readings.push({
      labels: labels.map(({ label }) => label),
      datasets: [{
        ...consumptionDatasetBarConfig,
        data: dataWithEstimates,
        // Cores diferentes para pontos estimados vs reais
        pointBackgroundColor: pointBackgroundColors,
        pointBorderColor: pointBorderColors,
        pointRadius: estimatedFlags.map((flag) => flag === null ? 6 : 4), // Pontos estimados maiores
        pointHoverRadius: estimatedFlags.map((flag) => flag === null ? 8 : 6), // Hover maior para estimados
        pointBorderWidth: estimatedFlags.map((flag) => flag === null ? 3 : 2), // Borda mais grossa para estimados
      }],
      modemId: reservoirId,
    });
  }

  return readings;
};

const createDataTable = (resume, selectedSector) => {
  const reservoirId = selectedSector.id_doc || selectedSector.id || selectedSector.id_modem

  if (Array.isArray(resume?.[0]) && resume[0].some((item) => Object.prototype.hasOwnProperty.call(item, 'value'))) {
    return [{
      items: resume[0]
        .filter((item) => item.value !== null && item.value !== undefined)
        .map((item) => ({
          date: item.label,
          value: Number(item.value).toFixed(2),
        })),
      modemId: reservoirId,
    }]
  }

  let readings_table = []
  let readingList = Object.values(resume)
  let modemIds = Object.keys(resume)
  readingList.forEach(
    (reading, index) => {
      let items = []
      items = reading.filter((item) => !item.isEstimative).map((item) => {
        const { waterHeight, waterVolume } = calculateReservoirLevel(
          getReadingValue(item, selectedSector),
          selectedSector.reservoirHeight,
          selectedSector.reservoirVolume,
          selectedSector.sensorMaxHeight,
        )
        return { date: item.formatedDate, value: waterHeight }
      })
      readings_table.push({
        items,
        modemId: modemIds[index]
      })
    }
  )
  return readings_table;
}

export default {
  calculateReservoirLevel,
  createLabels,
  checkPeriod,
  getSeriesFromReservoirs,
  getSectorPort,
  getDeviceCommunicationType,
  getReadingValue,
  createResumeConsumption,
  generateConsumption,
  createDataset,
  createDataTable,
}
